var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup__con_inner",staticStyle:{"max-height":"none"}},[_c('div',{staticClass:"privacy-wrap"},[_vm._v("개인정보 제공 동의서 준비중")])])}]

export { render, staticRenderFns }